import { create } from 'zustand';
import { api } from '../services/apiService';

export interface CalendarSlot {
  job_id: string;
  job_name: string;
  scheduled_at: string;
  status: 'completed' | 'failed' | 'upcoming' | 'missed';
  run_id?: number;
  duration_ms?: number;
  cost_usd?: number;
}

interface CalendarState {
  weekSchedule: CalendarSlot[];
  nextUp: CalendarSlot[];
  selectedDate: string;
  loading: boolean;
  fetchWeekSchedule: (date?: string) => Promise<void>;
  fetchNextUp: (hours?: number) => Promise<void>;
  setSelectedDate: (date: string) => void;
}

export const useCalendarStore = create<CalendarState>((set, get) => ({
  weekSchedule: [],
  nextUp: [],
  selectedDate: new Date().toISOString().split('T')[0],
  loading: false,

  fetchWeekSchedule: async (date?: string) => {
    const targetDate = date ?? get().selectedDate;
    try {
      set({ loading: true });
      const weekSchedule = await api.get<CalendarSlot[]>(`/calendar/week?date=${targetDate}`);
      set({ weekSchedule, loading: false });
    } catch (err) {
      console.error('Failed to fetch week schedule:', err);
      set({ loading: false });
    }
  },

  fetchNextUp: async (hours = 24) => {
    try {
      const nextUp = await api.get<CalendarSlot[]>(`/calendar/next-up?hours=${hours}`);
      set({ nextUp });
    } catch (err) {
      console.error('Failed to fetch next up:', err);
    }
  },

  setSelectedDate: (date: string) => {
    set({ selectedDate: date });
    get().fetchWeekSchedule(date);
  },
}));
